import moment from 'moment'
import { RuleTypes, Suggestion } from '@Bill/constants'
import { durationMaps } from '@Bill/views/suggestionrule/constants'
import i18n from '@/locales'
import store from '@/store'
import { currencyUnitMap } from '@/constants/currency'
import { numerify } from '@/filters'

let getMetircAlertUtil = null
const modules = require.context('../../../containers', true, /^((?![\\/]node_modules).)*.\/router\/index.js$/)
if (Array.prototype.includes.call(modules.keys(), './Monitor/router/index.js')) { // 如果当前项目包含 Monitor 模块，那么引入 getMetircAlertUtil 可以更友好的显示
  getMetircAlertUtil = require('../../Monitor/views/commonalert/utils/index.js').getMetircAlertUtil
}

export const getRuleTypeName = (type) => {
  const ruleType = RuleTypes.find((item) => { return item.key === type })
  return ruleType ? ruleType.label : type
}

export const getSuggest = (type) => {
  const Suggest = Suggestion.find((item) => { return item.key === type })
  return Suggest ? Suggest.label : type
}

const getScaleStrategy = (config) => {
  const metricMap = {
    'vm_cpu.usage_active': i18n.t('meter.suggestrule.metric.vm_cpu.usage_active', [i18n.t(`monitor.${config.reduce_type || 'avg'}`)]),
    'vm_mem.usage_active': i18n.t('meter.suggestrule.metric.vm_mem.usage_active', [i18n.t(`monitor.${config.reduce_type || 'avg'}`)]),
    'dcs_cachekeys.key_count': i18n.t('meter.suggestrule.metric.dcs_cachekeys.key_count', [i18n.t(`monitor.${config.reduce_type || 'avg'}`)]),
    'rds_cpu.usage_active': i18n.t('meter.suggestrule.metric.rds_cpu.usage_active', [i18n.t(`monitor.${config.reduce_type || 'avg'}`)]),
    'oss_req.req_count': i18n.t('meter.suggestrule.metric.oss_req.req_count', [i18n.t(`monitor.${config.reduce_type || 'avg'}`)]),
  }
  const metric = `${config.measurement}.${config.field}`
  const comparator = config.eval_type === 'within_range' ? i18n.t('meter.suggestrule.within') : config.eval_type
  const threshold = config.within_range ? `${config.within_range[0]}~${config.within_range[1]}` : config.threshold
  const unit = metric.includes('usage_active') ? '%' : ''
  return {
    strategy: `${metricMap[metric] || metric} ${config.reduce_type || ''} ${comparator} ${threshold}${unit}`,
    metric: metricMap[metric] || metric,
    unit,
  }
}

export const getRuleDesc = (type, setting = {}, row) => {
  const ruleDescMap = {
    // OSS_SEC_ACL: i18n.t('bill.text_266'),
    // SECGROUPRULEINSERVER_ALLIN: i18n.t('bill.text_267'),
    // CLOUDACCOUNT_AMOUNT_DAILY: i18n.t('bill.text_276'),
    // CLOUDACCOUNT_AMOUNT_MONTH: i18n.t('bill.text_277'),
    DISK_UNUSED: i18n.t('bill.text_263'),
    EIP_UNUSED: i18n.t('bill.text_264'),
    EXPIRE_SERVER_SKU: i18n.t('bill.text_rule_EXPIRE_SERVER_SKU'),
    LB_UNUSED: i18n.t('bill.text_86'),
    SNAPSHOT_UNUSED: i18n.t('bill.text_265'),
    UPGRADE_PREPAID: i18n.t('bill.text_rule_upgrade_prepaid'),
  }
  if (row && getMetircAlertUtil) {
    const { strategy, strategyConfig } = getMetircAlertUtil(row, 'common_alert_metric_details')
    if (strategy !== '-') return { strategy, strategyConfig }
  }
  if (setting.scale_rule) {
    const sett = setting.scale_rule.map((item, index) => {
      const strategy = getScaleStrategy(item)
      return {
        strategy: strategy.strategy,
        strategyConfig: {
          period: row.period,
          time_from: row.time_from,
          metric: strategy.metric,
          measurement: strategy.measurement,
          threshold: item.threshold,
          unit: strategy.unit,
          comparator: item.eval_type,
          within_range: item.within_range,
        },
      }
    })
    return sett.length === 1 ? sett[0] : sett
  }
  let str = ruleDescMap[type] || i18n.t('bill.text_87')
  if (row) {
    const zh = getTimeWithI18n(row.time_from)
    if (zh === '-') {
      return {
        strategy: str,
        strategyConfig: {
          period: row.period,
          measurement: str,
        },
      }
    }
    str = `${i18n.t('bill.text_262', [zh])}${str}`
  }
  return {
    strategy: str,
    strategyConfig: {
      measurement: str,
      period: row.period,
      time_from: row.time_from,
    },
  }
}
// 14d => 14天/14d
export const getTimeWithI18n = time => {
  if (!time) return '-'
  const timestr = time.replace(/(\d+)(\D+)/g, (str, $1, $2) => {
    return `${$1}${durationMaps[$2] || $2}`
  })
  return timestr
}

export const mergePredictData = (dataList, predData, dateMode) => {
  const predDataDict = {}
  for (const v in predData.data) {
    // ignore negative predict
    if (predData.data[v].stat_value >= 0) {
      predDataDict[predData.data[v].stat_date] = predData.data[v].stat_value
    } else {
      predDataDict[predData.data[v].stat_date] = 0.0
    }
  }
  var curDate
  if (dateMode === 'month') {
    curDate = moment().subtract(1, 'days').format('YYYY-MM-DD') + 'TZ'
  } else {
    curDate = moment().subtract(1, 'days').format('YYYY-MM') + 'TZ'
  }
  var predStartIndex = 0
  for (var i = dataList.length - 1; i >= 0; i--) {
    if (dataList[i].value > 0 || dataList[i].time === curDate) {
      predStartIndex = i
      break
    }
  }
  var retList = []
  // var predOffset = 0
  for (const i in dataList) {
    const v = {
      time: dataList[i].time,
      value: dataList[i].value,
    }
    if (i >= predStartIndex && predDataDict[dataList[i].time] && !v.value) {
      v.predict = predDataDict[dataList[i].time]
      v.isPredict = true
      // predOffset = predOffset + 1
    } else {
      v.predict = undefined //  v.value
    }
    retList.push(v)
  }
  // for (let i = predOffset; i < predData.data.length; i++) {
  //   retList.push({
  //     time: predData.data[i].stat_date,
  //     value: undefined, // 0.0,
  //     predict: predDataDict[predData.data[i].stat_date],
  //   })
  // }
  return retList
}

export const isCurrentMonth = (param = {}) => {
  const { start_date, end_date } = param
  const start = moment().startOf('month').format('YYYY-MM-DD') + 'TZ'
  const end = moment().endOf('month').format('YYYY-MM-DD') + 'TZ'
  if (start_date === start && end_date === end) {
    return true
  }
  return false
}

export const getProjectFilter = () => {
  return {
    label: i18n.t('res.project'),
    dropdown: true,
    multiple: false,
    distinctField: {
      type: 'field',
      key: 'project',
    },
  }
}

export const getDomainFilter = () => {
  return {
    label: i18n.t('table.title.domain'),
    dropdown: true,
    multiple: false,
    distinctField: {
      type: 'field',
      key: 'domain',
    },
    hidden: () => store.getters.isProjectMode,
  }
}

function getDiffValue (diffField1, diffField2, row) {
  return (row[diffField2] || 0) - (row[diffField1] || 0)
}

export const getBillColumn = ({ title, field, sortable = false, currencySign, showDiff, diffField1, diffField2 }) => {
  return {
    title,
    field,
    sortable,
    slots: {
      default: ({ row }, h) => {
        let sign = ''
        const { currency, exchanged_currency } = row
        let display_currency = exchanged_currency
        if (!display_currency) {
          display_currency = currency
        }
        if (currencySign) {
          sign = currencySign
        } else if (currencyUnitMap[display_currency]) {
          sign = currencyUnitMap[display_currency].sign || ''
        }
        const value = [<span>{`${sign} ${numerify(row[field] || 0, '0,0.00')}`}</span>]
        if (showDiff) {
          value.push(<span style="color:#9c9c9c">{` (${numerify(getDiffValue(diffField1, diffField2, row), '0,0.00')})`}</span>)
        }
        return value
      },
    },
    formatter: ({ row }) => {
      let sign = ''
      const { currency, exchanged_currency } = row
      let display_currency = exchanged_currency
      if (!display_currency) {
        display_currency = currency
      }
      if (currencySign) {
        sign = currencySign
      } else if (currencyUnitMap[display_currency]) {
        sign = currencyUnitMap[display_currency].sign || ''
      }
      let value = `${sign} ${numerify(row[field] || 0, '0,0.00')}`
      if (showDiff) {
        value += ` (${sign} ${numerify(getDiffValue(diffField1, diffField2, row), '0,0.00')})`
      }
      return value
    },
    needExportFormat: true,
  }
}

function getProperty (obj, property, defaultValue) {
  if (obj.hasOwnProperty(property)) {
    return obj[property]
  }
  return defaultValue
}

export const getAmountColumns = (params) => {
  const ret = []
  const dateModeTitle = params.dateModeTitle || (i18n.t(`bill.${params.dateMode}_fee`) ? i18n.t(`bill.${params.dateMode}_fee`) : i18n.t('bill.text_309'))
  if (store.getters.isAdminMode) {
    ret.push(getBillColumn({ currencySign: params.currencySign, title: dateModeTitle, field: getProperty(params, 'fieldMonth', 'amount'), sortable: getProperty(params, 'monthSortable', true) })) // 本月
    if (params.amountContractColumn) {
      ret.push(params.amountContractColumn)
    }
    if (!params.disable_cost_conversion) { // 开启二次定价
      // 本月-二次定价
      ret.push(getBillColumn({
        currencySign: params.currencySign,
        title: i18n.t('bill.after_cost_conversion_diff', [dateModeTitle]),
        field: getProperty(params, 'fieldSecondMonth', 'amount_sec'),
        showDiff: true,
        diffField1: getProperty(params, 'fieldMonth', 'amount'),
        diffField2: getProperty(params, 'fieldSecondMonth', 'amount_sec'),
      }))
    }
  } else {
    if (params.disable_cost_conversion) {
      ret.push(getBillColumn({ currencySign: params.currencySign, title: dateModeTitle, field: getProperty(params, 'fieldMonth', 'amount'), sortable: getProperty(params, 'monthSortable', true) })) // 本月
      if (params.amountContractColumn) {
        ret.push(params.amountContractColumn)
      }
    } else { // 开启二次定价
      // 是否允许非系统视图展示原账单
      const costConversionOrigin = store.getters.common.bill.costConversionOrigin
      if (!costConversionOrigin) {
        // 不允许域和项目视图展示原账单,直接展示应付金额为二次定价的金额
        ret.push(getBillColumn({
          currencySign: params.currencySign,
          title: dateModeTitle,
          field: getProperty(params, 'fieldMonth', 'amount_sec'),
        }))
      } else {
        ret.push(getBillColumn({
          currencySign: params.currencySign,
          title: dateModeTitle,
          field: getProperty(params, 'fieldMonth', 'amount'),
        }))
        ret.push(getBillColumn({
          currencySign: params.currencySign,
          title: i18n.t('bill.after_cost_conversion_diff', [dateModeTitle]),
          field: getProperty(params, 'fieldSecondMonth', 'amount_sec'),
          showDiff: true,
          diffField1: getProperty(params, 'fieldMonth', 'amount'),
          diffField2: getProperty(params, 'fieldSecondMonth', 'amount_sec'),
        }))
      }
    }
  }
  return ret
}

export const getCurrencyOptions = () => {
  const { currencyOpts = [] } = store.getters.common.bill
  return currencyOpts.map(val => {
    const currencyItem = { ...val }
    if (val.item_id.indexOf('*_') !== -1) { // 以xx为单位展示所有账单-原账单
      if ((process.env.BRAND?.en || '').toLowerCase() === 'multicloud') {
        currencyItem.item_name = i18n.t('bill.show_origin_2', [val.item_name.replace('*_', '')])
      } else {
        currencyItem.item_name = i18n.t('bill.show_origin_4', [val.item_name.replace('*_', '')])
      }
    } else if (val.item_id.indexOf('_') !== -1) { // 以xx为单位展示所有账单
      if ((process.env.BRAND?.en || '').toLowerCase() === 'multicloud') {
        const currency = val.item_name.replace('_', '')
        if (currency === 'USD') {
          currencyItem.item_name = i18n.t('bill.show_origin_3', ['BRL'])
        } else {
          currencyItem.item_name = i18n.t('bill.text_287', [val.item_name.replace('_', '')])
        }
      } else {
        currencyItem.item_name = i18n.t('bill.text_287', [val.item_name.replace('_', '')])
      }
    } else if (val.item_id.indexOf('*') !== -1) { // 仅展示xx账单-原账单
      currencyItem.item_name = i18n.t('bill.show_origin_1', [val.item_name.replace('*', '')])
    } else { // 仅展示xx账单
      currencyItem.item_name = i18n.t('bill.text_39', [val.item_name])
    }
    return currencyItem
  })
}

export const decodeCurrencyParamsFromCurrency = (currency) => {
  if (currency) {
    const params = {
      exchanged_currency: currency.replace('*', '').replace('_', ''),
      filter: [`currency.equals("${currency.replace('*', '').replace('_', '')}")`],
    }
    if (currency.indexOf('_') !== -1) {
      delete params.filter
    } else {
      params.exchanged_currency = ''
    }
    params.disable_cost_conversion = currency.indexOf('*') !== -1 || !store.state.common.bill.globalConfig.cost_conversion_available
    if (!params.disable_cost_conversion && store.getters.scope !== 'system') {
      params.secondary_price = true
    }
    return params
  }
  return {}
}

export const int2Date = (dateInt) => {
  const dateString = '' + dateInt
  const year = dateString.slice(0, 4)
  const month = Number(dateString.slice(4, 6)) - 1 // 月份需要减一，因为 Date 对象中月份是从 0 开始计数的
  const day = dateString.slice(6, 8)
  return new Date(year, month, day)
}

export const getBillResourceTypeLabel = (resourceType) => {
  if (!resourceType) return '-'
  return i18n.te(`bill_resource_type.${resourceType}`) ? `${i18n.t(`bill_resource_type.${resourceType}`)} (${resourceType})` : resourceType
}
